import React from 'react';
import './HUD.css';
import EscalationTimer from './EscalationTimer';

const SUIT_SYM  = { S: '♠', H: '♥', D: '♦', C: '♣' };
const SUIT_NAME = { S: 'Spades', H: 'Hearts', D: 'Diamonds', C: 'Clubs' };

export default function GameStatus({ gs }) {
  // THE FIX: Strictly separate the active ID based on the current game phase.
  // This completely ignores stale 'bid_winner' data during the live bidding phase.
  const isBiddingPhase = gs.phase === 'bidding';
  const activeBidderId = isBiddingPhase ? gs.current_bidder : gs.bid_winner;
  
  // THE FIX: If the ID is >= 0, someone holds the bid. No hardcoded math required!
  const hasBid = activeBidderId !== undefined && activeBidderId >= 0;
  const bidder = hasBid ? gs.players?.[activeBidderId] : null;
  
  // Cleanly fall back to "Waiting..." if the bidding phase just started
  const displayBid = hasBid ? gs.current_bid : '—';
  const bidderName = bidder ? bidder.name : (isBiddingPhase ? "Waiting..." : "Nobody");
  
  const isRevealed = gs.trump_revealed;
  const trumpSuit = gs.trump;

  const isDoubled = gs.doubled_by !== -1;
  const isRedoubled = gs.redoubled_by !== -1;
  const royalPairTeam = gs.royal_pair_team;
  
  const sprintRounds = gs.sprint_rounds || 0;
  const totalRoundsPlayed = gs.total_rounds_played || 0;
  const inSuddenDeath = gs.in_sudden_death;
  const isMatchOver = gs.phase === 'match_over';
  const escalationEnabled = gs.escalation_timer;
  const matchStartTime = gs.match_start_time;

  const displayedRound = isMatchOver 
    ? Math.max(1, totalRoundsPlayed) 
    : (inSuddenDeath ? totalRoundsPlayed + 1 : Math.min(totalRoundsPlayed + 1, sprintRounds));

  return (
    <div className={`status-card ${isRevealed ? 'trump-revealed' : 'trump-hidden'}`}>
      
      {escalationEnabled && <EscalationTimer matchStartTime={matchStartTime} />}
      
      {sprintRounds > 0 && (
        <div className="status-section" style={{ backgroundColor: inSuddenDeath ? '#ff2a2a40' : 'rgba(0,0,0,0.3)', padding: '6px', borderRadius: '8px', marginBottom: '8px', textAlign: 'center', alignItems: 'center' }}>
          <div className="status-label" style={{ color: inSuddenDeath ? '#ff4d4d' : 'var(--text-secondary)' }}>
            {inSuddenDeath ? 'SUDDEN DEATH!' : 'SPRINT SERIES'}
          </div>
          <div className="status-value-row" style={{ justifyContent: 'center' }}>
            <span className="status-big-text" style={{ fontSize: '1.2rem', color: inSuddenDeath ? '#ff4d4d' : 'var(--text-primary)' }}>
              {inSuddenDeath ? `Round: ${displayedRound}` : `Round: ${displayedRound} / ${sprintRounds}`}
            </span>
          </div>
        </div>
      )}

      {/* Top Section: Trump Info */}
      <div className="status-section">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <div className="status-label">THURUPPU (TRUMP)</div>
          {royalPairTeam !== -1 && (
            <span title="Royal Pair (Meli)" style={{ fontSize: '1.2rem', filter: 'drop-shadow(0 0 5px #f59e0b)' }}>👑</span>
          )}
        </div>
        {isRevealed ? (
          <div className={`status-value-row suit-${trumpSuit}`}>
            <span className="status-big-text">{SUIT_SYM[trumpSuit]}</span>
            <span className="status-sub-text">{SUIT_NAME[trumpSuit]}</span>
          </div>
        ) : (
          <div className="status-value-row hidden">
            <span className="status-big-text">🔒</span>
            <span className="status-sub-text">HIDDEN</span>
          </div>
        )}
      </div>

      <div className="status-divider" />

      {/* Bottom Section: Bid Info */}
      <div className="status-section">
        <div className="status-label">CURRENT BID</div>
        <div className={`status-value-row bid-value ${!hasBid ? 'hidden' : ''}`}>
          <span className="status-big-text">
            {displayBid}
            {isRedoubled ? (
              <span className="multiplier-badge x4">x4</span>
            ) : isDoubled ? (
              <span className="multiplier-badge">x2</span>
            ) : null}
          </span>
          <span className="status-sub-text">by {bidderName}</span>
        </div>
      </div>
      
    </div>
  );
}